import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "./ui/command";

export const SearchSelect = ({ value, onChange, options = [], placeholder, testId, disabled }) => {
  const [open, setOpen] = useState(false);
  const isDisabled = disabled || options.length === 0;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          disabled={isDisabled}
          className={`flex h-10 w-full items-center justify-between rounded-md border border-steel bg-ink px-3 text-sm text-white font-body focus:outline-none focus:ring-1 focus:ring-cyan disabled:opacity-40 disabled:cursor-not-allowed ${value ? "" : "text-slate-500"}`}
        >
          <span className="truncate">{value || placeholder}</span>
          <ChevronsUpDown size={14} className="shrink-0 text-slate-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="p-0 w-[--radix-popover-trigger-width] bg-surface border-steel">
        <Command className="bg-surface text-white">
          <CommandInput data-testid={`${testId}-search`} placeholder={`Search ${placeholder?.toLowerCase() || ""}...`} className="text-white" />
          <CommandList>
            <CommandEmpty>No match.</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem
                  key={o}
                  value={String(o)}
                  data-testid={`${testId}-${o}`}
                  onSelect={() => { onChange(String(o)); setOpen(false); }}
                  className="font-body text-slate-200 aria-selected:bg-elevated aria-selected:text-cyan cursor-pointer"
                >
                  <Check size={14} className={`mr-2 text-cyan ${value === String(o) ? "opacity-100" : "opacity-0"}`} />
                  {o}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
